import { styled } from 'styled-components';

import type { ApiFilestackImageData } from '#/api/types/ApiFilestackImageData';
import { Box } from '#/components/Box/Box';
import { Body } from '#/components/Text/Body';
import { H2 } from '#/components/Text/H2';
import { Tile } from '#/components/Tile/Tile';
import { colors } from '#/theme/theme';
import { trackAnchorClicked } from '#/utils/analytics/track/trackAnchorClicked';
import type { SpaceProps } from 'styled-system';
import { Button } from '#/components/Button/Button';

export const CmsTwoTilesBlockTile = styled(
  ({
    buttonText,
    buttonUrl,
    className,
    dataQaPrefix,
    headline,
    text,
    blockIndex,
    pageUpdated,
    ...props
  }: {
    buttonText: string | null;
    buttonUrl: string | null;
    className?: string;
    dataQaPrefix: string;
    headline: string;
    text: string;
    image?: ApiFilestackImageData;
    blockIndex: number;
    pageUpdated: string;
  } & SpaceProps) => (
    <Tile
      position="relative"
      display="flex"
      p={['20px', null, '60px']}
      alignItems="center"
      justifyContent="stretch"
      flexDirection="column"
      flex="1"
      overflow="hidden"
      textAlign="center"
      className={className}
      data-qa-prefix={dataQaPrefix}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <H2 m="0">{headline}</H2>
      <Box mt="20px" width="100%" flex="1 1 auto">
        <Body
          analyticsData={{
            eventName: 'CMS Block',
            eventProperties: {
              block_position: blockIndex,
              block_type: 'Two Tiles',
            },
          }}
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
      </Box>
      {buttonText && buttonUrl && (
        <Box mt={['32px', null, '52px']} width="100%">
          <Button
            variant="primary"
            type="link"
            href={buttonUrl}
            onClick={(event) =>
              trackAnchorClicked(event, 'CMS Block', {
                block_position: blockIndex,
                block_type: 'Two Tiles',
                cta_type: 'Button',
                button_text: buttonText,
                page_updated: pageUpdated,
              })
            }
          >
            {buttonText}
          </Button>
        </Box>
      )}
    </Tile>
  ),
)`
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 10px;
    background-image: linear-gradient(
      to left,
      ${colors.skyBlue},
      ${colors.brandBlue}
    );
    background-size: 100% 10px;
    background-repeat: no-repeat;
  }
`;
